import { DrawerProps } from '@mui/material/Drawer';
import { FC, PropsWithChildren } from 'react';
import { Drawer } from 'atoms/Drawer';
import { useSidebarHeight } from './hooks';
import styles from './styles.module.css';

export const SidebarDrawer: FC<PropsWithChildren<DrawerProps>> = ({
  children,
  open,
  onClose,
}) => {
  useSidebarHeight();

  return (
    <Drawer
      open={open}
      onClose={onClose}
      classes={{ paper: styles.drawer, root: styles.drawerContainer }}
      hideBackdrop
      ModalProps={{
        disableEnforceFocus: true,
      }}
      anchor="right"
    >
      {children}
    </Drawer>
  );
};
